import { useContext, useMemo, useState } from "react";
import { IAxiosError } from "../../../utils";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { ActualReportsGrid } from "./components/ReportGrids/ActualReportsGrid";

interface ILicenseReportsPageProps {
  textKey: string;
}
export function LicenseReportsPage(props: Readonly<ILicenseReportsPageProps>) {
  const { textKey } = props;
  const { res } = useContext(AvisContext);
  const [error, setError] = useState<IAxiosError>();
  const [conditionalTextKey, setConditionalTextKey] = useState<string>();

  const renderTable = useMemo(
    () => (
      <ActualReportsGrid
        setError={setError}
        onDataLoaded={(data) =>
          data.length > 0
            ? setConditionalTextKey("portal_LIC_OverdueReports_1")
            : setConditionalTextKey("portal_LIC_OverdueReports_2")
        }
      />
    ),
    [],
  );

  return (
    <AvisForm
      title={res("licensees_LicenseReports_PageTitle_actual")}
      error={error}
    >
      <AvisDescriptiveText textKey={textKey} />
      {conditionalTextKey && (
        <AvisDescriptiveText textKey={conditionalTextKey} />
      )}
      {renderTable}
    </AvisForm>
  );
}
